import client, { axiosBaseUrl } from './client';
import { VisitApi } from 'woofwoof-api';
import { AxiosRequestConfig } from 'axios';
import { VisitTranscriptionSpeakerValue } from 'src/types/visit-transcription';

export const visitApi = new VisitApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);

export const visitTranscriptionApi = {
  get: (visitId: string, options?: AxiosRequestConfig) =>
    visitApi.visitControllerGetVisitTranscription({ visitId }, options),
  start: (visitId: string) =>
    visitApi.visitControllerStartVisitTranscription({
      visitId,
      startVisitTranscriptionDto: { consentConfirmed: true },
    }),
  stop: (
    visitId: string,
    sessionId: string,
    errorMessage?: string,
    options?: AxiosRequestConfig,
  ) =>
    visitApi.visitControllerStopVisitTranscription(
      {
        visitId,
        stopVisitTranscriptionDto: {
          sessionId,
          errorMessage,
        },
      },
      options,
    ),
  updateSegment: (
    visitId: string,
    segmentId: string,
    speaker: VisitTranscriptionSpeakerValue,
    text: string,
  ) =>
    visitApi.visitControllerUpdateVisitTranscriptionSegment({
      visitId,
      updateVisitTranscriptionSegmentDto: {
        segmentId,
        speaker,
        text,
      },
    }),
};
